import { render, staticRenderFns } from "./Additem.vue?vue&type=template&id=cd0ac3ce&scoped=true&"
import script from "./Additem.vue?vue&type=script&lang=js&"
export * from "./Additem.vue?vue&type=script&lang=js&"
import style0 from "./Additem.vue?vue&type=style&index=0&id=cd0ac3ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0ac3ce",
  null
  
)

export default component.exports